import('./bootstrap').then(bootstrap => {
  bootstrap.default(document.getElementById('clumio') as HTMLElement);
});
